// JsFromRoutes CacheKey 7d11dcdacbd7594856476ff025bc9a44
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  get: definePathHelper('get', '(/:admin)/custom_clause_variants/export'),
  create: definePathHelper('post', '(/:admin)/custom_clause_variants/export')
}
